import { useEffect, useState } from "react";
import useMediaQuery from "../hooks/useMediaQuery";
import * as Const from "../_Const";
import { ScaleLoader } from "react-spinners";
import useScreenType from "../hooks/useScreenType";
import useCssProperty from "../hooks/useCssProperty";

const ScaleSpinnerProgressSection = ({ title, subTitle, footerTitle }) => {
  const screenType = useScreenType();
  const cssProperty = useCssProperty("--color-accent");

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "parent-div":
          css = "h-[330px] mt-4";
          break;
        case "title":
          css = "text-4xl";
          break;
        case "loader-div":
          css = "mt-8";
          break;
        case "loader-h":
          css = "100px";
          break;
        case "loader-w":
          css = "26px";
          break;
        case "sub-title":
          css = "text-4xl mt-4";
          break;
        case "footer-title":
          css = "text-xl mt-4";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "parent-div":
          css = "h-[550px] mt-8";
          break;
        case "title":
          css = "text-6xl";
          break;
        case "loader-div":
          css = "mt-24";
          break;
        case "loader-h":
          css = "150px";
          break;
        case "loader-w":
          css = "40px";
          break;
        case "sub-title":
          css = "text-6xl mt-12";
          break;
        case "footer-title":
          css = "text-3xl mt-12";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "parent-div":
          css = "h-[580px] mt-8";
          break;
        case "title":
          css = "text-6xl";
          break;
        case "loader-div":
          css = "mt-24";
          break;
        case "loader-h":
          css = "150px";
          break;
        case "loader-w":
          css = "40px";
          break;
        case "sub-title":
          css = "text-6xl mt-12";
          break;
        case "footer-title":
          css = "text-3xl mt-12";
          break;
      }
    } else if (screenType === Const.SCREEN_PHONE) {
      switch (what) {
        case "parent-div":
          css = "h-[550px] mt-8";
          break;
        case "title":
          css = "text-6xl";
          break;
        case "loader-div":
          css = "mt-24";
          break;
        case "loader-h":
          css = "150px";
          break;
        case "loader-w":
          css = "40px";
          break;
        case "sub-title":
          css = "text-6xl mt-12";
          break;
        case "footer-title":
          css = "text-3xl mt-12";
          break;
      }
    }
    //console.log(what, screenType, css);

    return css;
  }

  if (screenType === Const.SCREEN_UNKNOWN) {
    return;
  }

  return (
    <div className={`${getCssFor("parent-div")} flex flex-col w-full items-center place-items-center`}>
      {title && <h1 className={`${getCssFor("title")} text-accent text-center`}>{title}</h1>}
      <div className={`${getCssFor("loader-div")} flex-grow  items-center place-content-center`}>
        <ScaleLoader color={cssProperty} height={getCssFor("loader-h")} width={getCssFor("loader-w")} />
      </div>
      {subTitle && <p className={`${getCssFor("sub-title")} text-error-dark`}>{subTitle}</p>}
      {footerTitle && <p className={`${getCssFor("footer-title")} text-primary`}>{footerTitle}</p>}
    </div>
  );
};

export default ScaleSpinnerProgressSection;
